const ONE_MILLION = 1_000_000

const MILLIONS_THRESHOLD = 999_500

export const formatCurrencyAbbreviated = (value: number): string => {
  if (!Number.isFinite(value) || value <= 0) {
    return 'R$ 0,00'
  }

  if (value < MILLIONS_THRESHOLD) {
    const thousands = Math.round(value / 1000)
    return `R$ ${new Intl.NumberFormat('pt-BR').format(thousands)} mil`
  }

  const millions = Math.round((value / ONE_MILLION) * 10) / 10
  const formatted = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 }).format(millions)
  const unit = millions === 1 ? 'milhão' : 'milhões'

  return `R$ ${formatted} ${unit}`
}
